export const truncateURL = (url: string): string => {
  const urlObj = new URL(url)
  const { hostname, pathname } = urlObj
  const path = pathname.length > 1 ? pathname : ''
  return `${hostname.replace('www.', '')}/...${path.slice(-20)}`
}
